/**
 * API Client Functions für MFA / Recovery-Codes
 *
 * Endpoints unter /api/v2/auth/mfa
 */

import { apiClient } from '@/lib/api-client';

export interface MfaStatus {
  enrolled: boolean;
  codes_remaining: number;
  recovery_grace_until: string | null;
}

interface RecoveryCodesResponse {
  codes: string[];
}

/**
 * Lädt den aktuellen MFA-Status des Nutzers
 */
export async function fetchMfaStatus(): Promise<MfaStatus> {
  const response = await apiClient.get<MfaStatus>('/api/v2/auth/mfa/status');
  return response.data;
}

/**
 * Generiert einen neuen Satz Recovery-Codes
 */
export async function generateRecoveryCodes(): Promise<string[]> {
  const response = await apiClient.post<RecoveryCodesResponse>(
    '/api/v2/auth/mfa/recovery-codes'
  );
  return response.data.codes;
}

/**
 * Verbraucht einen Recovery-Code
 */
export async function consumeRecoveryCode(code: string): Promise<void> {
  await apiClient.post('/api/v2/auth/mfa/recovery-codes/consume', { code });
}
